import { format, parseJSON } from 'date-fns';
import * as React from 'react';
import { compose, defaultProps, lifecycle, withHandlers, withState } from 'recompose';
import { createStyles, Popover } from '@material-ui/core';
import { FontIcon } from '../../FontIcon';
import { withBaseProps } from '../../Utils';
import { DatePicker } from '../DatePicker';
import { TextInput } from '../TextInput';
const styles = createStyles({
    datePickerRoot: {
        position: 'static',
    },
    suffixRoot: {
        cursor: 'pointer',
        '&:hover': {
            opacity: 1,
        },
    },
});
const DatePickerInput = (props) => {
    const { classes, className, clearable, clearHandler, testId = 'DatePickerInput', dateFormat, datePickerProps, dateSelected, disabled, focusHandler, label, locale, open, placeholder, selectDateHandler, selectEndHandler, setOpen, t, name, ...others } = props;
    const { input, meta } = others;
    const ref = React.useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref },
            React.createElement(TextInput, { testId: `${testId}-input`, classes: { suffix: classes.suffixRoot }, className: className, disabled: open || disabled, input: input, label: label, meta: meta, onFocus: focusHandler, placeholder: placeholder || 'DD/MM/YYYY', postLabel: clearable && dateSelected && React.createElement(FontIcon, { onClick: clearHandler, iconName: "close", color: "currentColor" }), value: dateSelected && format(parseJSON(dateSelected), dateFormat) })),
        React.createElement(Popover, { "data-testid": `${testId}-popover`, anchorEl: ref.current, anchorOrigin: {
                horizontal: 'left',
                vertical: 'bottom',
            }, marginThreshold: 0, onClose: () => {
                setOpen(false);
            }, open: open, transformOrigin: {
                horizontal: 'left',
                vertical: 'top',
            }, disableRestoreFocus: true },
            React.createElement(DatePicker, Object.assign({ "data-testid": `${testId}-picker`, className: classes.datePickerRoot, currentDate: dateSelected && new Date(dateSelected), initialMonth: dateSelected ? new Date(dateSelected) : new Date(), locale: locale, onSelectDate: selectDateHandler, onSelectEnd: selectEndHandler, t: t }, datePickerProps)))));
};
const ComposedDatePickerInput = compose(defaultProps({
    clearable: true,
}), withBaseProps({ styles }), withState('open', 'setOpen', false), withState('dateSelected', 'setDateSelected', ({ initialDate, input }) => {
    return initialDate || (input && input.value ? new Date(input.value) : undefined);
}), withHandlers({
    selectDateHandler: ({ input, onDateChange, setDateSelected }) => (date) => {
        if (onDateChange) {
            onDateChange(date);
        }
        const dateISOString = date.toISOString();
        if (input && input.onChange) {
            input.onChange(dateISOString);
        }
        setDateSelected(dateISOString);
    },
    selectEndHandler: ({ setOpen }) => () => setOpen(false),
    focusHandler: ({ setOpen }) => () => setOpen(true),
    clearHandler: ({ setDateSelected, input, onDateChange }) => () => {
        if (onDateChange) {
            onDateChange('');
        }
        if (input && input.onChange) {
            input.onChange('');
        }
        setDateSelected('');
    },
}), lifecycle({
    componentDidUpdate(prevProps) {
        if (this.props.input && prevProps.input && this.props.input.value !== prevProps.input.value) {
            this.props.setDateSelected(this.props.input.value);
        }
    },
}))(DatePickerInput);
ComposedDatePickerInput.displayName = 'DatePickerInput';
export default ComposedDatePickerInput;
//# sourceMappingURL=DatePickerInput.js.map